import {defineStore} from "pinia";

export const useOrganizationalChartStore = defineStore('organizationalChart', {
    state: () => ({
        organizationalChart: {children: []},
        organizationalCharts: [],
        organizationalChartsSelect: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setOrganizationalChart(organizationalChart) {
            this.organizationalChart = organizationalChart;
        },
        setOrganizationalCharts(organizationalCharts) {
            this.organizationalCharts = organizationalCharts;
        },
        setOrganizationalChartsSelect(organizationalChartsSelect) {
            this.organizationalChartsSelect = organizationalChartsSelect;
        },
        addOrganizationalChart(organizationalChart) {
            this.organizationalCharts.unshift(organizationalChart)
        },
        updateOrganizationalChart(organizationalChart) {
            let index = this.organizationalCharts.findIndex(cl => cl.id === organizationalChart.id)
            this.organizationalCharts.splice(index, 1, organizationalChart)
        },
        deleteOrganizationalChart(organizationalChart) {
            let index = this.organizationalCharts.findIndex(cl => cl.id === organizationalChart.id)
            this.organizationalCharts.splice(index, 1)
        },

        addNode(newNode) {
            const findParent = (node) => {
                if (node.id === newNode.teteId) return node;
                const childrenToSearch = node.collapsed ? node.savedChildren : node.children;
                if (childrenToSearch) {
                    for (const child of childrenToSearch) {
                        const found = findParent(child);
                        if (found) return found;
                    }
                }
                return null;
            };

            // Start searching from the ROOT of the tree
            const parent = findParent(this.organizationalChart);

            if (parent) {
                if(parent.collapsed) {
                    parent.children = [...parent.savedChildren];
                    parent.savedChildren = [];
                    parent.collapsed = false;
                }
                parent.children.push(newNode);
            }
        },

        updateNode(updatedData) {
            const findNode = (node) => {
                if (node.id === updatedData.id) return node;
                if (node.children) {
                    for (const child of node.children) {
                        const found = findNode(child);
                        if (found) return found;
                    }
                }
                return null;
            };

            const nodeToUpdate = findNode(this.organizationalChart);
            if (nodeToUpdate) {
                nodeToUpdate.name = updatedData.name;
                nodeToUpdate.workerId = updatedData.workerId;
                nodeToUpdate.workerName = updatedData.workerName;
            } else {
                console.error('Node not found for update:', updatedData.id);
            }
        },

        removeNode(nodeId) {
            const findParent = (node) => {
                if (node.children) {
                    for (let i = 0; i < node.children.length; i++) {
                        if (node.children[i].id === nodeId) {
                            return {parent: node, index: i};
                        }
                        const result = findParent(node.children[i]);
                        if (result) return result;
                    }
                }
                return null;
            };

            const parentInfo = findParent(this.organizationalChart);

            if (parentInfo) {
                parentInfo.parent.children.splice(parentInfo.index, 1);
            }
        },

    },
});